module.exports = __webpack_public_path__ + "img/Group.b1b16829.png";